import { Link } from "react-router-dom";
import { Ear, Sparkles, LifeBuoy, ArrowRight } from "lucide-react";

const CARDS = [
    {
        icon: Ear, to: "/hearing-test", testid: "qs-hearing-test",
        title: "“I'm not sure I have hearing loss”",
        body: "Take the free 3-minute online screening — per-ear results with plain-language next steps.",
        cta: "Test my hearing",
    },
    {
        icon: Sparkles, to: "/find", testid: "qs-finder",
        title: "“I know I need one — which model?”",
        body: "Answer 5 questions on lifestyle, budget and priorities. Get a ranked shortlist with honest reasons.",
        cta: "Find my match",
    },
    {
        icon: LifeBuoy, to: "/support", testid: "qs-support",
        title: "“I already own a Signia device”",
        body: "Troubleshooting guides, doorstep repair requests, warranty claims and consumable reorders.",
        cta: "Open Support Centre",
    },
];

export const QuickStart = () => (
    <section className="py-14 md:py-20 bg-white border-y border-[#efece6]">
        <div className="container-x">
            <p className="eyebrow">Start where you are</p>
            <h2 className="font-serif text-[28px] md:text-[36px] mt-3 max-w-[680px]">Three journeys. Pick yours.</h2>
            <div className="mt-8 grid md:grid-cols-3 gap-5" data-testid="quick-start">
                {CARDS.map(({ icon: Icon, to, title, body, cta, testid }) => (
                    <Link key={to} to={to} data-testid={testid}
                        className="group p-7 rounded-2xl border border-[#e2ddd4] bg-[#FAF8F5] hover:border-[#003E4D] transition flex flex-col">
                        <Icon size={22} className="text-[#B8860B]" />
                        <h3 className="font-serif text-[20px] mt-4 leading-snug">{title}</h3>
                        <p className="text-[14px] text-[#4a5568] mt-2 flex-1">{body}</p>
                        <span className="mt-5 inline-flex items-center gap-1.5 text-[14px] font-medium text-[#003E4D]">{cta} <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" /></span>
                    </Link>
                ))}
            </div>
        </div>
    </section>
);

export default QuickStart;
